import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also attach token from localStorage as Authorization fallback
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("madymark_token");
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// SEC session_expired handler: on 401 with "session expired" (token_version
// mismatch → password changed elsewhere) clear local token and redirect to login.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const detail = err.response?.data?.detail || "";
    const path = window.location.pathname;
    // Only act on user-initiated calls after being logged in. Skip login page.
    if (status === 401 && /session expired/i.test(detail) && !path.startsWith("/login") && !path.startsWith("/sifre")) {
      localStorage.removeItem("madymark_token");
      // Prevent infinite loops if already redirecting
      if (!window.__madymark_401_redirect__) {
        window.__madymark_401_redirect__ = true;
        window.location.href = "/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

export const COMPANY_LOGO =
  "https://customer-assets-agu9un31.emergentagent.net/job_8984de44-402a-4963-bfe4-ef21ab1de824/artifacts/rzex8chg_WhatsApp%20Image%202026-04-16%20at%2012.38.29.jpeg";

export const CURRENCY_SYMBOL = { TRY: "₺", USD: "$", EUR: "€" };

export const formatMoney = (v, cur = "TRY") => {
  const sym = CURRENCY_SYMBOL[cur] || "";
  const n = Number(v || 0);
  return `${sym}${n.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatPrice = (v, cur = "TRY") => {
  const sym = CURRENCY_SYMBOL[cur] || "";
  return `${sym}${Number(v || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 7 })}`;
};

export const formatDate = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("tr-TR");
  } catch {
    return d;
  }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

/**
 * openDownload — SEC-002 secure download helper.
 * Issues a short-lived single-use ticket for the given path, then opens the
 * full URL (path + optional query) with `?ticket=<xxx>` appended. Falls back
 * to opening the URL without a token if ticket creation fails — the server
 * will 401 in that case and the user will see the error.
 *
 * @param {string} path  — API path starting with /api/  (no query string)
 * @param {object} query — optional key/value pairs appended as query string
 */
export const openDownload = async (path, query = {}) => {
  try {
    const { data } = await api.post("/download-ticket", { path });
    const qs = new URLSearchParams({ ...query, ticket: data.ticket }).toString();
    window.open(`${API_BASE}${path}?${qs}`, "_blank");
  } catch (err) {
    // Fallback opens URL without token — server responds 401, browser shows it
    const qs = new URLSearchParams(query).toString();
    window.open(`${API_BASE}${path}${qs ? "?" + qs : ""}`, "_blank");
  }
};
